import { takeLatest, put, call } from 'redux-saga/effects';

import { filterUsuarioProdutor } from '../service';
import {
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_USUARIO_PRODUTOR } from '@commons/consts';

function* sagaNewFilterNextPageUsuarioProdutor(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING });

  try {
    let filterSaved =
      sessionStorage.getItem(CONST_FILTER_USUARIO_PRODUTOR) !== null
        ? JSON.parse(sessionStorage.getItem(CONST_FILTER_USUARIO_PRODUTOR))
        : null;

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(
      filterUsuarioProdutor,
      newFilter.where || '',
      newFilter.page,
      newFilter.rows,
    );

    sessionStorage.setItem(
      CONST_FILTER_USUARIO_PRODUTOR,
      JSON.stringify(newFilter),
    );

    yield put({
      type: NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS,
      list: list,
      filter: newFilter,
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE });
  }
}

export default function* watchNewFilterNextPageUsuarioProdutor() {
  yield takeLatest(
    NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR,
    sagaNewFilterNextPageUsuarioProdutor,
  );
}
